var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { shade } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { colors, cssThemedValue, cssVarsThemed, typographyCss } from '@creditornot/cb-ingredients';
import { createCssVarDefinitions, createCssVars, themedConfigToThemedAttrs, } from '@creditornot/cb-utils';
var variantCssVars = createCssVars(['color', 'colorHover', 'colorActive', 'colorDisabled']);
var variantConfigs = {
    blue: {
        light: {
            color: colors.wolt100,
            colorHover: colors.wolt92,
            colorActive: shade(0.15)(colors.wolt100),
            colorDisabled: colors.wolt40,
        },
        dark: {
            color: colors.wolt100,
            colorHover: colors.wolt92,
            colorActive: colors.wolt76,
            colorDisabled: colors.wolt48,
        },
    },
    black: {
        light: {
            color: colors.pepper100,
            colorHover: colors.pepper92,
            colorActive: colors.pepper84,
            colorDisabled: colors.pepper52,
        },
        dark: {
            color: colors.salt100,
            colorHover: colors.salt92,
            colorActive: colors.salt80,
            colorDisabled: colors.salt60,
        },
    },
    grey: {
        light: {
            color: colors.pepper64,
            colorHover: colors.pepper56,
            colorActive: colors.pepper76,
            colorDisabled: colors.pepper32,
        },
        dark: {
            color: colors.salt72,
            colorHover: colors.salt64,
            colorActive: colors.salt52,
            colorDisabled: colors.salt32,
        },
    },
    lightGrey: {
        light: {
            color: colors.pepper48,
            colorHover: colors.pepper40,
            colorActive: colors.pepper60,
            colorDisabled: colors.pepper20,
        },
        dark: {
            color: colors.salt60,
            colorHover: colors.salt52,
            colorActive: colors.salt48,
            colorDisabled: colors.salt28,
        },
    },
    white: {
        light: {
            color: colors.salt100,
            colorHover: colors.salt92,
            colorActive: colors.salt80,
            colorDisabled: colors.salt64,
        },
        dark: {
            color: colors.salt100,
            colorHover: colors.salt92,
            colorActive: colors.salt80,
            colorDisabled: colors.salt64,
        },
    },
    lightWhite: {
        light: {
            color: colors.salt56,
            colorHover: colors.salt48,
            colorActive: colors.salt44,
            colorDisabled: colors.salt28,
        },
        dark: {
            color: colors.salt56,
            colorHover: colors.salt48,
            colorActive: colors.salt44,
            colorDisabled: colors.salt28,
        },
    },
    red: {
        light: {
            color: colors.strawberry100,
            colorHover: colors.strawberry92,
            colorActive: shade(0.15)(colors.strawberry100),
            colorDisabled: colors.strawberry72,
        },
        dark: {
            color: colors.strawberry100,
            colorHover: colors.strawberry92,
            colorActive: colors.strawberry76,
            colorDisabled: colors.strawberry72,
        },
    },
    yellow: {
        light: {
            color: colors.banana100,
            colorHover: colors.banana92,
            colorActive: shade(0.15)(colors.banana100),
            colorDisabled: colors.banana72,
        },
        dark: {
            color: colors.banana100,
            colorHover: colors.banana92,
            colorActive: colors.banana76,
            colorDisabled: colors.banana72,
        },
    },
    orange: {
        light: {
            color: colors.orange100,
            colorHover: colors.orange92,
            colorActive: shade(0.15)(colors.orange100),
            colorDisabled: colors.orange72,
        },
        dark: {
            color: colors.orange100,
            colorHover: colors.orange92,
            colorActive: colors.orange76,
            colorDisabled: colors.orange72,
        },
    },
    green: {
        light: {
            color: colors.lime100,
            colorHover: colors.lime92,
            colorActive: shade(0.15)(colors.lime100),
            colorDisabled: colors.lime72,
        },
        dark: {
            color: colors.lime100,
            colorHover: colors.lime92,
            colorActive: colors.lime76,
            colorDisabled: colors.lime72,
        },
    },
};
var sizeCssMap = {
    inherit: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    font-size: inherit;\n    line-height: inherit;\n  "], ["\n    ", "\n    font-size: inherit;\n    line-height: inherit;\n  "])), typographyCss.baseFontFamily),
    small: typographyCss.Body3,
    medium: typographyCss.Body2,
    large: typographyCss.Body1,
};
var iconSizeConfigs = {
    inherit: '0.75em',
    small: '12px',
    medium: '14px',
    large: '16px',
};
var sizeCssVars = createCssVars(['iconSize']);
/**
 * Note: exported only to assist creating the link variants.
 */
export var rootCss = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  position: relative;\n  font-feature-settings: 'kern';\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  /* stylelint-disable font-family-no-missing-generic-family-keyword */\n  font-family: ", ";\n  /* stylelint-enable font-family-no-missing-generic-family-keyword */\n\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n  ", "\n  font-weight: 500;\n\n  user-select: ", ";\n\n  white-space: ", ";\n\n  &:disabled {\n    cursor: not-allowed;\n    color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n\n  &:not(:disabled):hover {\n    color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n\n  &:not(:disabled):active {\n    color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n\n  :focus:not(:focus-visible) {\n    outline: none;\n  }\n  :focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px ", ";\n    border-radius: 2px;\n  }\n"], ["\n  ", "\n\n  ", "\n\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  position: relative;\n  font-feature-settings: 'kern';\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  /* stylelint-disable font-family-no-missing-generic-family-keyword */\n  font-family: ", ";\n  /* stylelint-enable font-family-no-missing-generic-family-keyword */\n\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n  ", "\n  font-weight: 500;\n\n  user-select: ", ";\n\n  white-space: ", ";\n\n  &:disabled {\n    cursor: not-allowed;\n    color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n\n  &:not(:disabled):hover {\n    color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n\n  &:not(:disabled):active {\n    color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n\n  :focus:not(:focus-visible) {\n    outline: none;\n  }\n  :focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px ", ";\n    border-radius: 2px;\n  }\n"])), function (_a) {
    var $variant = _a.$variant;
    return cssVarsThemed(themedConfigToThemedAttrs(variantConfigs[$variant]));
}, function (_a) {
    var $cssVarOverrides = _a.$cssVarOverrides, $size = _a.$size;
    return createCssVarDefinitions(__assign({ iconSize: iconSizeConfigs[$size] }, $cssVarOverrides));
}, function (_a) {
    var $fontFamily = _a.$fontFamily;
    return $fontFamily === 'inherit'
        ? 'inherit'
        : "-apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', Arimo, 'Open Sans', 'Helvetica Neue', sans-serif";
}, variantCssVars.color, function (_a) {
    var $size = _a.$size;
    return sizeCssMap[$size];
}, function (_a) {
    var $disableTextSelect = _a.$disableTextSelect;
    return ($disableTextSelect ? 'none' : 'inherit');
}, function (_a) {
    var $wrapText = _a.$wrapText;
    return ($wrapText ? 'normal' : 'nowrap');
}, variantCssVars.colorDisabled, variantCssVars.colorDisabled, variantCssVars.colorHover, variantCssVars.colorHover, variantCssVars.colorActive, variantCssVars.colorActive, cssThemedValue('a11yFocusIndicator'));
var Root = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), rootCss);
var DisabledButtonOnMouseLeaveFix = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"])));
var IconContainer = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: inline-block;\n  flex-shrink: 0;\n  line-height: 0;\n\n  margin-inline-start: ", "px;\n  margin-inline-end: ", "px;\n\n  > svg {\n    fill: ", ";\n    width: ", ";\n  }\n"], ["\n  display: inline-block;\n  flex-shrink: 0;\n  line-height: 0;\n\n  margin-inline-start: ", "px;\n  margin-inline-end: ", "px;\n\n  > svg {\n    fill: ", ";\n    width: ", ";\n  }\n"])), function (_a) {
    var $position = _a.$position;
    return ($position === 'left' ? 0 : 8);
}, function (_a) {
    var $position = _a.$position;
    return ($position === 'right' ? 0 : 8);
}, variantCssVars.color, sizeCssVars.iconSize);
/**
 * Note: exported only to assist creating the link variants.
 */
export var TextButtonContent = function (_a) {
    var children = _a.children, icon = _a.icon, iconPosition = _a.iconPosition;
    return (React.createElement(React.Fragment, null,
        !!icon && iconPosition === 'left' && (React.createElement(IconContainer, { "$position": iconPosition }, icon)),
        children,
        !!icon && iconPosition === 'right' && (React.createElement(IconContainer, { "$position": iconPosition }, icon))));
};
var TextButton = React.forwardRef(function (_a, ref) {
    var children = _a.children, cssVarOverrides = _a.cssVarOverrides, disabled = _a.disabled, _b = _a.disableTextSelect, disableTextSelect = _b === void 0 ? false : _b, _c = _a.fontFamily, fontFamily = _c === void 0 ? 'default' : _c, icon = _a.icon, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'left' : _d, _e = _a.size, size = _e === void 0 ? 'small' : _e, _f = _a.type, type = _f === void 0 ? 'button' : _f, _g = _a.variant, variant = _g === void 0 ? 'blue' : _g, _h = _a.wrap, wrap = _h === void 0 ? false : _h, restButtonProps = __rest(_a, ["children", "cssVarOverrides", "disabled", "disableTextSelect", "fontFamily", "icon", "iconPosition", "size", "type", "variant", "wrap"]);
    return (React.createElement(Root, __assign({ "$cssVarOverrides": cssVarOverrides, "$disableTextSelect": disableTextSelect, "$fontFamily": fontFamily, "$size": size, "$variant": variant, "$wrapText": wrap, disabled: disabled, type: type }, restButtonProps, { ref: ref }),
        React.createElement(DisabledButtonOnMouseLeaveFix, null),
        React.createElement(TextButtonContent, { icon: icon, iconPosition: iconPosition }, children)));
});
TextButton.displayName = 'TextButton';
export default TextButton;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=TextButton.js.map